import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { showModal, clearConfirmationDialog } from 'Store/ui/actions';
import { clearAllListMessages } from 'Store/lists/actions';
import { removeStudentFromClass } from 'Store/classes/actions';
import * as reducers from 'Store/reducers';

import WithClassStudents from 'Containers/WithClassStudents';
import AddStudentButton from 'Containers/AddStudentButton';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import UsersListHeader from 'Components/UsersListHeader';
import ListGroup from 'Components/ListGroup';
import UsersList from 'Containers/UsersList/UsersList';
import AddStudent from 'Components/AddStudent';
import ConfirmationDialog from 'Components/ConfirmationDialog';

class ClassStudentsList extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      headerStuck: false,
      columnHeaderStuckTop: 0,
    };
    this.animationTimeout = null;
    this.areWeStuck = this.areWeStuck.bind(this);
  }

  componentDidMount() {
    // Show the “Add Student” modal if there are no students.
    if (this.props._class.student_ids.length === 0)
      this.props.showModal('class-student');

    this.animationTimeout = window.setInterval(this.areWeStuck, 10);
  }

  componentDidUpdate(prevProps) {
    // If the user responds to the “Remove Student” confirmation dialog,
    // remove the student from the class.
    const nextDialog = this.props.confirmationDialog;
    if (
      nextDialog &&
      typeof nextDialog.response === 'boolean' &&
      prevProps.confirmationDialog &&
      prevProps.confirmationDialog.response === null
    ) {
      if (nextDialog && nextDialog.response) {
        prevProps.removeStudentFromClass(
          nextDialog.settings.data.userId,
          nextDialog.settings.data.classId
        );
      }
      prevProps.clearConfirmationDialog();
    }
  }

  componentWillUnmount() {
    window.clearInterval(this.animationTimeout);
    this.props.clearAllListMessages();
    this.props.clearConfirmationDialog();
  }

  areWeStuck() {
    const { headerStuck } = this.state;
    if (window.pageYOffset > this.groupEl.offsetTop && !headerStuck) {
      this.setState({ headerStuck: true });
    }

    if (window.pageYOffset <= this.groupEl.offsetTop && headerStuck) {
      this.setState({ headerStuck: false });
    }
  }

  render() {
    const {
      _class,
      isModalActive,
      list,
      message,
      confirmationDialog,
    } = this.props;
    const { headerStuck, columnHeaderStuckTop } = this.state;

    const sharedButtonProps = {
      type: 'student',
      groupType: 'class',
      key: 'button-1',
      hideLimitCount: true,
      buttonType: isModalActive ? 'secondary-transparent' : 'secondary-mono',
    };

    const listHeader = (
      <UsersListHeader
        headerStuck={headerStuck}
        type="student"
        key="UsersListHeader"
        saveHeight={height => this.setState({ columnHeaderStuckTop: height })}
        title={
          <ConnectedFormattedMessage
            id="users_list_header.students_title"
            values={{ result_count: list.ids.length }}
          />
        }
        actionButtons={[<AddStudentButton {...sharedButtonProps} />]}
        message={message}
      />
    );

    return (
      <div
        ref={div => {
          this.groupEl = div;
        }}
      >
        <ListGroup groupType="class">
          {isModalActive
            ? [
                listHeader,
                <AddStudent key="AddStudentButton-Header" groupType="class" />,
              ]
            : listHeader}
          <UsersList
            groupType="class"
            type="students_in_class"
            groupId={_class.id}
            list={list}
            isLoading={list.isFetching}
            stickyOffset={0}
            headerStuck={headerStuck}
            virtualized={false}
          />
          {list.ids.length > 10 ? (
            <div
              className={`ListGroup__footer ${
                isModalActive ? 'is-in-edit-state' : ''
              }`}
            >
              <div className="ListGroup__footer-content">
                {<AddStudentButton {...sharedButtonProps} />}
              </div>
            </div>
          ) : null}
        </ListGroup>
        {confirmationDialog ? (
          <ConfirmationDialog {...confirmationDialog} />
        ) : null}
      </div>
    );
  }
}

ClassStudentsList.propTypes = {
  _class: PropTypes.shape({
    student_ids: PropTypes.array,
    id: PropTypes.number,
  }),
  isModalActive: PropTypes.bool,
  list: PropTypes.object,
  message: PropTypes.object,
  confirmationDialog: PropTypes.object,
  showModal: PropTypes.func.isRequired,
  removeStudentFromClass: PropTypes.func.isRequired,
  clearConfirmationDialog: PropTypes.func.isRequired,
  clearAllListMessages: PropTypes.func.isRequired,
};

const mapStateToProps = (state, { list }) => {
  return {
    isModalActive: reducers.isModalActive(state, 'class-student'),
    confirmationDialog: reducers.getConfirmationDialog(
      state,
      'removeStudentFromClass'
    ),
    message: list.message,
  };
};

export default WithClassStudents(
  connect(mapStateToProps, {
    showModal,
    removeStudentFromClass,
    clearConfirmationDialog,
    clearAllListMessages,
  })(ClassStudentsList)
);
